export class MasterParkingDevice {
  DEVICE_ID: number;
  DEVICE_NAME: string;
  CONNECTION_TYPE: string;
  DEVICE_IP: string;
  PORT: string;
  PORT_BOOM: string;
  SETTINGS: string;
  DEVICE_FUNCTION: string;
  READING_FUNCTION: string;
  GATE_TYPE: string;
  SYNC_CLOCK: number;
  ACTIVE_ANPR: number;
  ANPR_IP: string;
  ANPR_PORT: string;
  LANE_ID: string;
  STATUS: number;
  SELECTED: boolean;
  DISPLAY_DEVICE_IP: string;
  DISPLAY_DEVICE_PORT: string;
}
